import React from "react"
import { createNativeStackNavigator } from "@react-navigation/native-stack"
import Consent from "@Screens/Consent/Consent"
import PersonalData from "@Screens/UserSettings/SupportAndHelp/PersonalData/PersonalData"
import MyAccountStack from "./MyAccountStack/MyAccountStack"

const SettingStackNavigator = createNativeStackNavigator()
const UserSettingStack = () => {
    return (
        <SettingStackNavigator.Navigator
            screenOptions={{
                headerShown: false
            }}
            initialRouteName="UserSettingsScreen"
        >
            <SettingStackNavigator.Screen name="UserSettingsScreen" component={MyAccountStack} />
            <SettingStackNavigator.Screen name="Consent" component={Consent} />
            <SettingStackNavigator.Screen name="PersonalData" component={PersonalData} />
        </SettingStackNavigator.Navigator>
    )
}

export default UserSettingStack
